import type theme from '#build/ui/input-number'
import type { DeepPartial } from '@nuxt/ui'
import { inputCompoundVariants, inputDefaultVariants, inputVariants } from './input'

const inputNumber: DeepPartial<typeof theme> = {
  slots: {
    root: 'group',
    base: 'shadow-xs transitions-normal focus:outline-hidden w-full rounded-sm border-0 disabled:opacity-100',
    increment: '',
    decrement: '',
  },
  variants: {
    size: {
      xs: 'gap-1 px-2 py-1 text-xs',
      sm: 'gap-1.5 px-2.5 py-1.5 text-xs',
      md: 'gap-1.5 px-2.5 py-1.5 text-sm',
      lg: 'gap-2 px-3 py-4 text-base',
      xl: 'gap-2 px-3 py-2 text-base',
    },
    variant: {
      ...inputVariants.variant,
    },
  },
  compoundVariants: [{
    color: 'neutral',
    variant: 'outline',
    class: {
      increment: 'text-cvt-burgundy-600',
      decrement: 'text-cvt-burgundy-600',
    },
  }, {
    color: 'error',
    variant: 'outline',
    class: {
      increment: 'text-cvt-burgundy-600',
      decrement: 'text-cvt-burgundy-600',
    },
  }, ...inputCompoundVariants as any],
  defaultVariants: { ...inputDefaultVariants as any },
}

export default inputNumber
